import {ServiceIdentifier} from "@infonova/framework/lib/service/types/ServiceIdentifier";
import {serviceIdentifier} from "@infonova/framework/lib/service/serviceIdentifier";
import {serviceRegistry} from "@infonova/framework/lib/service/configuration/serviceRegistry";
import {byConstructor} from "@infonova/framework/lib/service/factory/byConstructor";
import { AddressServiceImpl } from "./address/AddressServiceImpl";
import {ApiConfiguration} from "./ApiConfiguration";
import { AddressesV1Addresses } from "./address/AddressesV1Addresses";
import {AddressService} from "./address/AddressService";
import { CustomerAccountsService } from "./customer-accounts/CustomerAccountService";
import { CustomersCustomerAccounts } from "./customer-accounts/CustomersCustomerAccounts";
import { CustomerAccountServiceImpl } from "./customer-accounts/CustomerAccountRelationshipServiceImpl";

export class ServiceConfiguration {
    static readonly AddressService: ServiceIdentifier<AddressService> = serviceIdentifier<AddressService>("addressService");
    static readonly CustomerAccountRelationshipService: ServiceIdentifier<CustomerAccountsService> = serviceIdentifier<CustomerAccountsService>("customerAccountsService");

    static configure() {
        serviceRegistry().registerSingletonFactory(ServiceConfiguration.AddressService, byConstructor<AddressService, AddressesV1Addresses>(AddressServiceImpl, ApiConfiguration.AddressesV1Addresses))
        serviceRegistry().registerSingletonFactory(ServiceConfiguration.CustomerAccountRelationshipService, byConstructor<CustomerAccountsService, CustomersCustomerAccounts>(CustomerAccountServiceImpl, ApiConfiguration.CustomersV1CustomerAccounts))
    }

}